export default __webpack_public_path__ + "static/media/AppStore2.991016dd.png";